import { cdnBase } from "../../const";

export default {
  en_us: {
    langKeys: {
      en_us: "English (US)",
    },
    interstitial: {
      heading: "Leaving this Site",
      copy: `By clicking "continue" you'll be leaving this web site and landing on a third-party site, which is governed by different terms and privacy policies.`,
      continue: "Continue",
      cancel: "Cancel",
    },
    ga: {
      copy:
        "We use cookies on this site to help improve your experience. By using this site, you consent to the use of cookies. Our Cookies Policy explains what cookies are, how we use cookies, how third­parties we may partner with may use cookies on the Service, your choices regarding cookies and further information about cookies.",
      continue: "Continue",
      disable: "Disable Cookies",
    },
    brand: "Calm",
    applinks: {
      apple: "LINK TO APPLE APP",
      google: "LINK TO GOOGLE APP",
    },
    chooseRegion: "Choose Language",
    loading: "Loading",
    select: "Select",
    clearAll: "Clear All",
    filters: "Filters",
    details: "Details",
    instructions: "download Instructions",
    videoInstructions: "video Instructions",
    warnings: {
      enableIframes: "You Must Enable iFrames to view this video",
    },
    helmet: {
      siteTitle: " | Calm ",
      meta_description:
        "Spin Master has partnered with the #1 sleep and meditation app, Calm, to bring you Calm Puzzles. Enjoy assembling these mindful puzzles while listening to peaceful audio content, allowing you to lower stress and improve your mood. Begin your journey to a happier and healthier life with a free 30-day subscription to the Calm app when you purchase a Calm puzzle.",
      tags: ``,
    },
    navigation: {
      mainmenu: [
        // {
        //   type: 'internal',
        //   href: '/instructions',
        //   display: 'Shop Now',
        //   icon: null

        // },
        
        {
          type: "internal",
          href: "/",
          mobileOnly: true,
          display: "Home",
          icon: null,
        },
        {
          type: "internal_hash",
          href: "#wheretobuy",
          display: "Where To Buy",
          icon: null,
        },
        // {
        //   type: 'external',
        //   href: 'https://www.spinmaster.com/support.php?userLoc=us',
        //   display: 'Support',
        //   icon: null

        // }
      ],
    },
    footer: {
      brand: "Spin Master",
      contactUs: "Contact Us",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      support: "Support",
      copy: "Spin Master Ltd. All Rights Reserved.",
      contactLink:
        "https://www.spinmaster.com/contact-us.php?userLoc=us&display=customer_service_info",
      privacyLink: "https://www.spinmaster.com/privacy-policy.php?userLoc=us",
      termsLink: "https://www.spinmaster.com/terms-of-service.php?userLoc=us",
      supportLink: "https://www.spinmaster.com/support.php?userLoc=us",
    },
    home: {
      title: "Home",
      whereToBuy: "Where To Buy",
      videoCTA: {
        src: `${cdnBase}videos/CandyLocks_Recut_30_v3.13a.mp4`,
      },
      sections: {
        hero: {
          img: `${cdnBase}Calm-Banner-1_v2-X2.jpg`,
          bgImg: `${cdnBase}Calm-Banner-1_v2-X2.jpg`,
          heading: `Calm Mindful<br/>Puzzle Collection`,
          copy: `Begin your journey to a healthier life. Relax and enjoy assembling these mindful puzzles while listening to peaceful audio content.`,
          cta: {
            copy: `Shop Now`,
            link: ``,
          },
        },
        steps: {
          heading: "Find Inner Peace by Piece",
          img: `${cdnBase}boxheadphonesNEW.jpg`,
          quietCopy: "* Available with every purchase",
          steps: [
            "Download the app",
            "Begin your journey with a <strong>FREE 30-Day Trial *</strong>",
            "Choose your soothing meditation",
            "Keep Calm and Puzzle On",
          ],
        },

        retailers: {
          header: "where to buy",
          retailers: [
            // {
            //   name: "Target",
            //   id: `target`,
            //   href: "https://www.target.com/",
            //   img: `${cdnBase}logos/logo-target%402x.png`,
            // },
            {
              name: "Amazon",
              id: `amazon`,
              href: "https://www.amazon.com/stores/page/B60AFCA1-4CBA-40D0-9ECE-68A3A0DF9A3A",
              img: `${cdnBase}logos/amazon.jpg`,
            },
            {
              name: "Walmart",
              id: `walmart`,
              href: "https://www.walmart.com/ip/300-Piece-Calm-Puzzle-for-Relaxation-Stress-Relief-and-Mood-Elevation-for-Adults-and-Kids-Ages-8-and-up-Calm-Coral/609267766",
              img: `${cdnBase}logos/walmart.jpg`,
            },
            {
              name: "Target",
              id: `target`,
              href: "https://www.target.com/p/spin-master-calm-app-sunflower-fields-jigsaw-puzzle-300pc/-/A-80635485#lnk=sametab",
              img: `${cdnBase}logos/target.jpg`,
            },
          ],
        },
      },
      variants: {
        id: "variants",
        header: "Discover the Variants",
        profiles: {
          nummybay: {
            header: "Nummy Bay",
            id: "nummybay",
            thumbnail: `https://via.placeholder.com/400x250`,
            copy:
              "Un(i)believably delicious! Nummy Bay is the tastiest place in all of Uni-Verse, where Unis represent their favorite foods!   ",
            bgImage: `https://via.placeholder.com/400x250`,
            bgImage_alt: "Nummy Bay Unicorn Images",
          },
          sweettreatslanding: {
            header: "Sweet Treats Landing",
            id: "sweettreatslanding",
            thumbnail: `https://via.placeholder.com/400x250`,
            copy:
              "These Unis have a real sweet hoof! Inspired by the yummiest desserts, these are the sweetest Unis in the whole Uni-Verse!",
            bgImage: `https://via.placeholder.com/400x250`,
            bgImage_alt: "Sweet Treats Landing Unicorn Images",
          },
          petpartypeak: {
            header: "Pet Party Peak",
            id: "petpartypeak",
            thumbnail: `https://via.placeholder.com/400x250`,
            copy:
              "A magical mashup! Get ready for the most whimsical animal-themed unicorns you’ve ever seen!",
            bgImage: `https://via.placeholder.com/400x250`,
            bgImage_alt: "Pet Party Peak Unicorn Images",
          },
          mist_teriousland: {
            header: "Mist-Terious Land",
            id: "mist_teriousland",
            thumbnail: `https://via.placeholder.com/400x250`,
            copy:
              "The flavor of life is alive and well with these Unis! Inspired by the beauty of nature, these Unis love the outdoors!",
            bgImage: `https://via.placeholder.com/400x250`,
            bgImage_alt: "Mist-Terious Land Unicorn Images",
          },
          funtasyland: {
            header: "Funtasyland",
            id: "funtasyland",
            thumbnail: `https://via.placeholder.com/400x250`,
            copy:
              "Ain’t no party like a Uni party! Funtasyland is a world packed full of fun, celebrations, and Unis!",
            bgImage: `https://via.placeholder.com/400x250`,
            bgImage_alt: "Funtasyland Unicorn Images",
          },
          glam_a_ganza: {
            header: "Glam-A-Ganza Land",
            id: "glam_a_ganza",
            thumbnail: `https://via.placeholder.com/400x250`,
            copy:
              "Bea-Uni-Ful! Glam-A-Ganza Land is a fashion-lovers paradise! Every Uni here LOVES fashion, makeup, and glitter!",
            bgImage: `https://via.placeholder.com/400x250`,
            bgImage_alt: "Glam-A-Ganza Land Unicorn Images",
          },
          superstar_city: {
            header: "SuperStar City",
            id: "superstar_city",
            thumbnail: `https://via.placeholder.com/400x250`,
            copy:
              "Where you can be as Uni-que as you want! Superstar City is the place to be whatever or whomever you want! ",
            bgImage: `https://via.placeholder.com/400x250g`,
            bgImage_alt: "SuperStar City Unicorn Images",
          },
        },
      },
      slides: [
        {
          heading: "Slide 1",
          subheading: "Lorem ipsum dolor sit amet.",
          img: "http://via.placeholder.com/1920x600",
          img2x: "http://via.placeholder.com/1920x600",
        },
        {
          heading: "Slide 2",
          subheading: "Lorem ipsum dolor sit amet.",
          img: "http://via.placeholder.com/1920x600",
          img2x: "http://via.placeholder.com/1920x600",
        },
        {
          heading: "Slide 3",
          subheading: "Lorem ipsum dolor sit amet.",
          img: "http://via.placeholder.com/1920x600",
          img2x: "http://via.placeholder.com/1920x600",
        },
      ],
    },
    collection: {
      title: "Candylocks Dream Collection",
      nextPage: "Next Page",
      prevPage: "Prev Page",
      all: "All",
      wantIt: "Want it",
      haveIt: "Have it",
      flipIt: "Facts",
      scent: "Scent",
      rarity: "Rarity",
      color: "Color",
      showing: "Showing",
      filters: ["scent", "rarity", "color"],
    },
    support: {
      title: "Support",
      subTitle: "Support",
    },
    toys: {
      title: "Toys",
      subTitle: "Toys",
      learn: "learn",
      more: "more",
    },
    toy: {
      title: "Toy",
      subTitle: "Toy",
      backToToys: "Back to Toys",
      features: "Features",
      image: "Image",
      contents: "Contents",
      whereToBuy: "Where to Buy",
      instructions: "Instructions",
      videoInstructions: "Video Instructions",
      brandSite: "brand site",
      buyNow: "Buy Now",
      retailers: "Retailers",
    },
    videos: {
      title: "Videos",
      subTitle: "Videos",
      playVideo: "Play Video",
      playButton_Alt: "play button",
      defaultVideoIndex: 0,
      categories: "Categories",
      catList: ["all", "commercials", "influencer"],
      videoList: [
        {
          title: "Commercial 1",
          video: `${cdnBase}videos/CandyLocks_Recut_30_v3.13a.mp4`,
          thumb: "https://via.placeholder.com/400x250",
          type: "default",
          categories: ["all", "commercials"],
        },
        {
          title: "Commercial 2",
          video: `${cdnBase}videos/CandyLocks_Recut_30_v3.13a.mp4`,
          thumb: "https://via.placeholder.com/400x250",
          type: "default",
          categories: ["all", "commercials"],
        },
        {
          title: "influencer Video",
          video: `${cdnBase}videos/CandyLocks_Recut_30_v3.13a.mp4`,
          thumb: "https://via.placeholder.com/400x250",
          type: "default",
          categories: ["all", "influencer"],
        },
        // {
        //   title:'Youtube Video',
        //   video:`Sx3ORAO1Y6s`,
        //   thumb: 'https://via.placeholder.com/400x250',
        //   type: 'youtube',
        //   categories: ['all','influencer'],
        // }
      ],
    },
    nomatch: {
      title: "Page Not Found",
    },
  },
};



// WEBPACK FOOTER //
// ./src/il8n/en_us/index.js